import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TeacherPayrollRecord {
  id: string;
  รูปแบบพนักงาน: string;
  รหัสบัตรประชาชน: string;
  'ชื่อจริง-นามสกุล': string;
  รหัส: string;
  ชื่อเล่น: string;
  เลขบัญชี: string;
  ธนาคาร: string;
  เงินเดือน: number;
  รูปแบบคอมมินชั่น: string;
  ค่าคอมมิชชั่น: number;
  Allowance: number;
  รวมเงินเดือน: number;
  'รูปแบบภงด.': string;
  ประกันสังคม: number;
  'ภงด.3': number;
  'ภงด.1': number;
  'ลาหยุด LWOP': number;
  เงินสุทธิ: number;
  คืนเงินประกัน: number;
  หักเงินประกัน: number;
  เงินสุทธิรวมประกัน: number;
  เงินเดือนประจำเดือน: number;
  เงินเดือนประจำปี: number;
  Email: string;
  ที่อยู่ผู้เสียภาษี: string;
  รูปแบบเงินเดือน: string;
  ประเภทพนักงาน: string;
  วันที่จ่าย: string;
  month: number;
  year: number;
  slip_url: string | null;
  tavi_50_url: string | null;
  is_tax_pnd3: boolean | null;
  generated_slip_at: string | null;
  generated_tavi_50_at: string | null;
  sent_slip_at: string | null;
  sent_slip_to_email: string | null;
}

export function useTeacherPayroll(month: number, year: number) {
  return useQuery({
    queryKey: ['teacher-payroll', month, year],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('v_teacher_payroll_monthly')
        .select('*')
        .eq('month', month)
        .eq('year', year);

      if (error) throw error;
      return data as unknown as TeacherPayrollRecord[];
    }
  });
}
